<template>
    <div>
        <div class="tips" :class="{'open': canOpen}">
            <div class="tips__container">
                <div class="d-flex align-items-center justify-content-center" style="min-height: 100%">
                    <div style="width: 100%; padding: 16px; max-width: 570px;">
                        <div v-show="type==='pragmatics'">
                            <h5 class="text-center pb40 pb16:sm mb0">
                                Speech Blubs has helped more than <span class="font-weight-bold">2 million kids</span> speak
                                their first words!
                            </h5>
                            <div class="d-flex align-items-center justify-content-center pb24">
                                <div class="mr16">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                                              fill="#5AD2AA"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M7 14.905C7 16.298 8.397 17.428 10.12 17.428C11.842 17.428 13.238 16.298 13.238 14.905C13.238 13.513 11.842 12.383 10.119 12.383C8.397 12.383 7 13.513 7 14.905Z"
                                              fill="white"/>
                                        <path d="M12.73 14.905V7.15503" stroke="white" stroke-width="1.017"
                                              stroke-linecap="square"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M12.221 6.56501V9.89901C12.221 9.89901 15.616 9.95901 17.157 11.989C17.354 12.249 17.765 12.086 17.726 11.763C17.462 9.55301 16.469 5.96501 12.789 6.00001C12.476 6.00401 12.221 6.25201 12.221 6.56501Z"
                                              fill="white"/>
                                    </svg>
                                </div>
                                <p style="width: calc(100% - 40px); max-width: 255px" class="mb0">
                                    <span class="font-weight-bold">23+ million</span> sounds and words produced by kids!
                                </p>
                            </div>
                            <div class="d-flex align-items-center justify-content-center pb24 pb16:sm">
                                <div class="mr16">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                                              fill="#5AD2AA"/>
                                        <path d="M16.2145 9.62805C15.9832 7.74045 14.4934 6.25444 12.6052 6.02788C12.4427 6.00933 12.2792 6.00003 12.1155 6C10.4468 6.00257 8.94433 7.01104 8.30977 8.55438C7.67521 10.0977 8.03383 11.8714 9.21812 13.047C9.8479 13.6501 10.2086 14.4813 10.2189 15.3532V15.8294H14.0237V15.3507C14.0265 14.4953 14.3745 13.6772 14.9888 13.0819C15.9166 12.1867 16.3704 10.908 16.2145 9.62819V9.62805H16.2145Z"
                                              fill="white"/>
                                        <path d="M12.1214 19.0001C12.5244 18.9996 12.8835 18.7457 13.0183 18.3659H11.2245C11.3593 18.7457 11.7184 18.9996 12.1214 19.0001Z"
                                              fill="white"/>
                                        <path d="M10.5359 17.4151C10.5361 17.5901 10.6779 17.7319 10.853 17.7322H13.3895C13.5645 17.7319 13.7063 17.5901 13.7066 17.4151V16.4639H10.5359V17.4151Z"
                                              fill="white"/>
                                    </svg>
                                </div>
                                <p style="width: calc(100% - 40px); max-width: 255px" class="mb0">
                                    <span class="font-weight-bold">650+ thousand hours</span> of Smart Screen Time
                                    delivered!
                                </p>
                            </div>
                            <div class="pt16 pb40 pb16:sm d-flex justify-content-center">
                                <div>
                                    <img src="https://cdn.speechblubs.com/2020/11/Family-using-Speech-Blubs-1-1.png">
                                </div>
                            </div>
                        </div>
                        <div v-show="type==='play'">
                            <h5 class="text-center pb40 mb0 font-weight-bold pb16:sm">
                                The App that gets parents emotional!
                            </h5>
                            <div style="border-left: solid 8px #FED14C; padding: 0 16px;">
                                <p>
                                    "My 2.5 year old hasn’t spoken a word with purpose until we downloaded this app! He now
                                    says “mama” and “dada”! <b>I am just so ecstatic I can hear my child finally call me mama!</b>
                                    😭 Thank you, Speech Blubs!"
                                </p>
                            </div>
                            <div class="d-flex justify-content-center pt40 pb16 pt16:sm">
                                <div class="pt16">
                                    <img src="https://cdn.speechblubs.com/2020/11/app-of-the-day-copy@3x-1.png">
                                </div>
                            </div>
                            <div class="d-flex justify-content-center pt16">
                                <div>
                                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M10.1428 15.2971L3.89884 19.2171L5.69751 12.0674L0.0397949 7.3403L7.39553 6.84156L10.1428 0L12.8902 6.84156L20.2459 7.3403L14.5883 12.0674L16.3869 19.2171L10.1428 15.2971Z"
                                              fill="#FED14C"/>
                                    </svg>
                                </div>
                                <div>
                                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M10.1428 15.2971L3.89884 19.2171L5.69751 12.0674L0.0397949 7.3403L7.39553 6.84156L10.1428 0L12.8902 6.84156L20.2459 7.3403L14.5883 12.0674L16.3869 19.2171L10.1428 15.2971Z"
                                              fill="#FED14C"/>
                                    </svg>
                                </div>
                                <div>
                                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M10.1428 15.2971L3.89884 19.2171L5.69751 12.0674L0.0397949 7.3403L7.39553 6.84156L10.1428 0L12.8902 6.84156L20.2459 7.3403L14.5883 12.0674L16.3869 19.2171L10.1428 15.2971Z"
                                              fill="#FED14C"/>
                                    </svg>
                                </div>
                                <div>
                                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M10.1428 15.2971L3.89884 19.2171L5.69751 12.0674L0.0397949 7.3403L7.39553 6.84156L10.1428 0L12.8902 6.84156L20.2459 7.3403L14.5883 12.0674L16.3869 19.2171L10.1428 15.2971Z"
                                              fill="#FED14C"/>
                                    </svg>
                                </div>
                                <div>
                                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M10.1428 15.2971L3.89884 19.2171L5.69751 12.0674L0.0397949 7.3403L7.39553 6.84156L10.1428 0L12.8902 6.84156L20.2459 7.3403L14.5883 12.0674L16.3869 19.2171L10.1428 15.2971Z"
                                              fill="#FED14C"/>
                                    </svg>
                                </div>
                            </div>
                            <p class="text-center font-weight-bold pb16">
                                4.4 Appstore rating
                            </p>
                        </div>
                        <div v-show="type==='comprehension'">
                            <h5 class="text-center pb40 mb0 font-weight-bold pb16:sm">
                                A science backed approach to speech development!
                            </h5>
                            <div class="d-flex align-items-center justify-content-center pb24">
                                <div class="mr16">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#5AD2AA"/>
                                        <path d="M17.348 12.7211H12.2287V11.6658H17.3913V7.37714H12.2287V6H11.174V7.37714H5.95803L4 9.5215L5.95803 11.6658H11.174V12.7212H5.91475V17.0098H11.174V24H12.2287V17.0098H17.348L19.306 14.8655L17.348 12.7211Z" fill="white"/>
                                    </svg>
                                </div>
                                <p style="width: calc(100% - 40px); max-width: 265px" class="mb0">
                                    Based on modelling:<br>
                                    <span class="font-weight-bold">Focusing your kid's attention</span>
                                </p>
                            </div>
                            <div class="d-flex align-items-center justify-content-center pb24">
                                <div class="mr16">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#5AD2AA"/>
                                        <path d="M16.2145 9.62805C15.9832 7.74045 14.4934 6.25444 12.6052 6.02788C12.4427 6.00933 12.2792 6.00003 12.1155 6C10.4468 6.00257 8.94433 7.01104 8.30977 8.55438C7.67521 10.0977 8.03383 11.8714 9.21812 13.047C9.8479 13.6501 10.2086 14.4813 10.2189 15.3532V15.8294H14.0237V15.3507C14.0265 14.4953 14.3745 13.6772 14.9888 13.0819C15.9166 12.1867 16.3704 10.908 16.2145 9.62819V9.62805H16.2145Z" fill="white"/>
                                        <path d="M12.1215 19.0001C12.5244 18.9996 12.8835 18.7457 13.0183 18.3659H11.2246C11.3594 18.7457 11.7185 18.9996 12.1215 19.0001Z" fill="white"/>
                                        <path d="M10.5359 17.4151C10.5361 17.5901 10.6779 17.7319 10.853 17.7322H13.3895C13.5645 17.7319 13.7063 17.5901 13.7066 17.4151V16.4639H10.5359V17.4151Z" fill="white"/>
                                    </svg>
                                </div>
                                <p style="width: calc(100% - 40px); max-width: 265px" class="mb0">
                                    Educational stories:<br>
                                    <span class="font-weight-bold">Delivering Smart Screen Time</span>
                                </p>
                            </div>
                            <div class="d-flex align-items-center justify-content-center pb24 pb16:sm">
                                <div class="mr16">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#5AD2AA"/>
                                        <path d="M18 10.694C18 7.478 15.388 5 12 5C8.612 5 6 7.478 6 10.694C6 13.44 8.824 16.99 11.294 17.594L10.376 18.464C10.306 18.531 10.236 18.732 10.306 18.799C10.376 18.933 10.518 19 10.659 19H13.412C13.552 19 13.694 18.933 13.765 18.799C13.835 18.665 13.765 18.531 13.695 18.464L12.705 17.594C15.177 16.99 18 13.44 18 10.693V10.694ZM8.118 10.694C8.118 10.894 7.976 11.029 7.765 11.029C7.553 11.029 7.412 10.895 7.412 10.694C7.412 8.282 9.459 6.34 12 6.34C12.212 6.34 12.353 6.474 12.353 6.675C12.353 6.875 12.212 7.01 12 7.01C9.812 7.01 8.118 8.617 8.118 10.694Z" fill="white"/>
                                    </svg>
                                </div>
                                <p style="width: calc(100% - 40px); max-width: 265px" class="mb0">
                                    Fun games & stickers:<br>
                                    <span class="font-weight-bold">Rewarding your kid for learning</span>
                                </p>
                            </div>
                            <div class="d-flex justify-content-center">
                                <div>
                                    <img src="https://cdn.speechblubs.com/2020/11/Group-97-1.png">
                                </div>
                            </div>
                        </div>
                        <div v-show="type==='talking'">
                            <h5 class="text-center pb40 mb0 font-weight-bold pb16:sm">
                                Certified & Approved App
                            </h5>
                            <div class="d-flex justify-content-center">
                                <div class="ml8 mr8">
                                    <img src="https://cdn.speechblubs.com/2020/11/image-1.png" class="img:sm">
                                </div>
                                <div class="ml8 mr8">
                                    <img src="https://cdn.speechblubs.com/2020/11/image-2.png" class="img:sm">
                                </div>
                                <div class="ml8 mr8">
                                    <img src="https://cdn.speechblubs.com/2020/11/MCA_Logo_Gold-1.png" class="img:sm">
                                </div>
                                <div class="ml8 mr8">
                                    <img src="https://cdn.speechblubs.com/2020/11/image-4.png" class="img:sm">
                                </div>
                            </div>
                            <div class="d-flex justify-content-center pt40 pb40 pt16:sm pb16:sm">
                                <div>
                                    <img src="https://cdn.speechblubs.com/2020/11/Speech-Blubs-App-1-1.png">
                                </div>
                            </div>
                        </div>
                        <div v-if="loading">
                            <div class="d-flex justify-content-center">
                                <div class="tips__loader" :class="{'active': animation}"></div>
                            </div>
                            <p class="text-center font-weight-bold pt16" style="font-size: 14px">
                                Preparing next questions...
                            </p>
                        </div>
                        <div class="d-flex justify-content-center" v-else>
                            <button class="btn btn-purple btn-lg" @click="next()">
                                Next question
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "screener-popup",
        props: {
            open: {
                required: true,
            },
            type: {
                required: true,
            }
        },
        data () {
            return {
                loading: false,
                animation: false,
            }
        },
        computed: {
            canOpen () {
                const opn = this.$root.query.cards && this.open && (this.type === 'pragmatics' || this.type === 'play' || this.type === 'comprehension' || this.type === 'talking');
                if (opn) {
                    this.loading = true;
                    setTimeout(() => {
                        this.animation = true;
                    }, 50);
                    setTimeout(() => {
                        this.loading = false;
                        this.animation = false;
                    }, 5000)
                }
                return opn;
            }
        },
        methods: {
            next () {
                this.$emit('next');
            }
        }
    }
</script>
